import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  Typography,
  useTheme,
} from "@mui/material";
import { clearUserData } from "utils/storage";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "store";
import { actions } from "../../layout/appLayoutSlice";
import { resetAll } from "slice/hostSlice";
import { resetMerchantState } from "slice/merchantSlice";
import { clearTrips } from "slice/tripSlice";

interface LogoutModalProps {
  open: boolean;
  onClose: () => void;
}

const LogoutModal = ({ open, onClose }: LogoutModalProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleLogout = () => {
    dispatch(resetMerchantState());
    dispatch(resetAll());
    dispatch(actions.resetUserDetails());
    dispatch(clearTrips());

    clearUserData();
    navigate("/signIn");
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      sx={{ 
        textAlign: "center",
        '& .MuiDialog-paper': {
          width: isMobile ? '90%' : '400px',
          maxWidth: '400px',
          borderRadius: 2,
          px: isMobile ? 1 : 2,
        },
      }}
      aria-labelledby="logout-dialog-title"
    >
      <DialogTitle 
        id="logout-dialog-title"
        sx={{ 
          fontWeight: 600, 
          pt: 3,
          fontSize: isMobile ? '1.25rem' : '1.5rem',
        }}
      >
        Confirm Logout
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          Are you sure you want to log out of your account?
        </Typography>
      </DialogContent>
      <DialogActions 
        sx={{ 
          justifyContent: "center", 
          pb: 3,
          pt: 1,
          px: 3,
          gap: 2,
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ 
            width: isMobile ? '100%' : '120px', 
            textTransform: "none",
            py: 1,
            borderRadius: 1.5,
            fontWeight: 500,
            '&:hover': {
              backgroundColor: theme.palette.background.default,
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleLogout}
          sx={{ 
            width: isMobile ? '100%' : '120px', 
            textTransform: "none",
            py: 1,
            borderRadius: 1.5,
            fontWeight: 500,
            boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
            '&:hover': {
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
            },
          }}
        >
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutModal;